<div *ngIf="deviceParamGatewayV3">

<div class="edit-container-params" *ngIf="editable && mainForm">
    <h4>Main</h4>
    <form [formGroup]="mainForm">

        <mat-form-field>
            <mat-label>Network idx :</mat-label>
            <input matInput placeholder="Id" formControlName="networks_idx" type="number"
                   (change)="setDeviceWithForm()">
        </mat-form-field>

        <mat-form-field>
            <mat-label>Dyn DNS :</mat-label>
            <input matInput placeholder="Url" formControlName="dynDns" type="text"
                   (keyup)="setDeviceWithForm()">
        </mat-form-field>
    </form>
</div>

<div *ngIf="!editable" class="read-container-params">
    <h4>Main</h4>
    <mat-form-field>
        <mat-label>Network idx :</mat-label>
        <input matInput placeholder="Id" [value]="deviceParamGatewayV3.networks_idx" [readonly]="true">
    </mat-form-field>

    <mat-form-field>
        <mat-label>Dyn DNS :</mat-label>
        <input matInput placeholder="Url"
               [value]="deviceParamGatewayV3.dynDns !== undefined ? deviceParamGatewayV3.dynDns : ''" [readonly]="true">
    </mat-form-field>
</div>

</div>
